import { useTranslation } from 'react-i18next';

import {
  normalizeUpdateNoticeLanguage,
} from '../config/updateNoticeConfig';

export default function useUpdateNoticeLanguage() {
  const { i18n } = useTranslation();

  const noticeLanguage = normalizeUpdateNoticeLanguage(
    i18n.resolvedLanguage || i18n.language,
    'ko',
  );

  return {
    noticeLanguage,
  };
}
